<template>
  <div class="users">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>用户列表</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/users/create')"
          >创建用户</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <el-row>
        <el-col :span="9">
          <el-input
            placeholder="请输入账号或用户姓名"
            v-model="params.uname"
            class="input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="userSearch"
            ></el-button>
          </el-input>
        </el-col>
        <!-- <el-col :span="9">&nbsp;</el-col>
        <el-col :span="9">
          <el-date-picker
            v-model="params.date"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col> -->
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable :tableData="userList" :columns="columns" />
      <!-- 表格 -->

      <!-- 分页 -->
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="params.pagenum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="userList.length"
      >
      </el-pagination> -->
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑弹框 -->
    <Edit
      v-if="roles.length > 0"
      :state="editState"
      @close="editState = false"
      :user="editUser"
      :roles="roles"
      @confirm="changeUser"
    />
    <EditPassword
      :state="editPasswordState"
      @close="editPasswordState = false"
      @confirm="changePassword"
    />
    <!-- 编辑弹框 end -->
  </div>
</template>

<script>
import TzTable from '@/components/tz-table/Index.vue'
import Edit from './components/Edit.vue'
import EditPassword from './components/EditPassword.vue'
import { brequest } from '@/utils/brequest'

export default {
  components: {
    TzTable,
    Edit,
    EditPassword
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
    },
    deleteFn(row) {
      console.log('删除2', row)

      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    async queryAllUserInfo() {
      let userInfos = await brequest({
        url: '/back/user/queryAllUserInfo'
      })
      this.allUsers = userInfos
      this.userFilter()
    },
    userFilter() {
      let ulist
      if (!this.params.uname) {
        ulist = this.allUsers
      } else {
        ulist = this.allUsers.filter(
          (rec) =>
            rec.loginName.includes(this.params.uname) ||
            rec.userName.includes(this.params.uname)
        )
      }
      this.userList = ulist.map((rec) => {
        return {
          ...rec,
          deactive: rec.state > 0
        }
      })
    },
    userSearch() {
      this.userFilter()
      this.params.pagenum = 1
    },
    async changeUserState(userInfo) {
      userInfo.state = userInfo.deactive ? 1 : 0

      let ret = await brequest({
        url: '/back/user/updateUserState',
        data: { id: userInfo.id, state: userInfo.state }
      })
      this.loading().close()
      if (ret) {
        this.$message({
          message: '用户状态更新成功',
          type: 'success'
        })
      }
    },
    async changePassword(password) {
      let ret = await brequest({
        url: '/back/user/updateUserPassword',
        data: { id: this.editUser.id, password: password }
      })
      if (ret) {
        this.editPasswordState = false
        this.$message({
          message: '用户密码更新成功',
          type: 'success'
        })
      }
    },
    async changeUser(user) {
      this.$loading({
        text: '用户信息更新中'
      })
      let ret = await brequest({
        url: '/back/user/updateUser',
        data: user
      })
      this.$loading().close()
      if (ret) {
        this.editState = false
        this.$message({
          message: '用户信息更新成功',
          type: 'success'
        })
        let row = this.allUsers.find((rec) => rec.id === user.id)
        row.loginName = user.loginName
        row.userName = user.userName
        row.mobilePhone = user.mobilePhone
        row.roleId = user.roleId
        row.roleName = this.roles.find((rec) => rec.value === user.roleId).label
        this.userFilter()
      }
    },
    async queryRoles() {
      let ret = await brequest({
        url: '/back/user/queryAllRoles'
      })
      this.roles = ret.map((rec) => {
        return {
          value: rec.id,
          label: rec.roleName
        }
      })
    }
  },
  data() {
    return {
      // 编辑表单数据
      editState: false,
      editPasswordState: false,
      editUser: {},
      // 筛选模型
      params: {
        uname: '',
        // date: [],
        pagenum: 1
      },
      // 表格列
      columns: [
        { title: '账号', field: 'loginName' },
        { title: '所属角色', field: 'roleName' },
        { title: '姓名', field: 'userName' },
        { title: '手机号', field: 'mobilePhone' },
        // { title: "冻结", field: "state" },
        {
          title: '在用',
          type: 'switch',
          payload: {
            field: 'deactive',
            change: (row) => this.changeUserState(row)
          }
        },
        // { title: '更新于', field: 'update_time', width: '180' },
        {
          title: '操作',
          width: '260',
          type: 'btn',
          payload: [
            {
              name: '修改用户',
              type: 'primary',
              click: (row) => {
                console.log('修改', row)
                this.editUser = JSON.parse(JSON.stringify(row))
                // 1 显示弹框
                this.editState = true
                // 2.
              }
            },
            {
              name: '更改密码',
              type: 'success',
              click: (row) => {
                console.log('分配角色', row)
                // 1 显示弹框
                this.editUser = row
                this.editPasswordState = true
                // 2.
              }
              // },
              // {
              //   name: '删除',
              //   type: 'danger',
              //   click: (row) => this.deleteFn(row)
            }
          ]
        }
      ],
      // 表格数据
      userList: [],
      allUsers: [],
      roles: []
    }
  },
  mounted() {
    this.queryAllUserInfo()
    this.queryRoles()
  }
}
</script>

<style lang="scss" scoped>
// history
// .history {
// }
</style>
